/**
 * FMA Training Vault Tour Steps
 * Tour for training video library
 * Supports role-based messaging for agents vs agencies
 */
import { Step } from "react-joyride";

export function getFmaTrainingSteps(isAgent: boolean): Step[] {
  return [
    {
      target: "body",
      content:
        "Welcome to the Training Vault! Watch free training videos and earn points to boost your ranking.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="search-filters"]',
      content:
        "Search videos by title or filter by category (Leadership, Sales, Product Knowledge), difficulty level, and tags.",
      placement: "top",
      disableScrolling: true,
    },
    {
      target: '[data-tour="video-card"]',
      content:
        "Each video shows the title, contributing agency, release date, target level, and topic tags.",
      placement: "top",
    },
    {
      target: '[data-tour="play-video"]',
      content: isAgent
        ? "Click play to watch. Complete videos to earn points and unlock rewards!"
        : "Click play to watch. If you have an Elite or Pro membership, submit your own videos to attract the right agents to your profile and earn points to level up! You can do this from your Account.",
      placement: "center",
    },
  ];
}
